import styled from 'styled-components';
import CardModal from '../../modal';
import { IconDocument, IconPhoto } from '../../icons';

export const Modal = styled(CardModal)``;

export const TitleSection = styled.h4`
  margin: 20px 0 15px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 20px;
  text-align: left;
  width: 100%;
`;

export const ImageArea = styled.button`
  width: 166px;
  height: 166px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const ImageInput = styled.input`
  display: none;
`;

export const Image = styled.img.attrs({ className: 'img-responsive' })`
  overflow: hidden;
  border-radius: 9px;
  width: 166px;
  height: 166px;
`;

export const ChangePass = styled.label`
  margin: -4px 0px 8px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
  font-style: italic;
  text-decoration: underline;
  text-align: left;
  width: 100%;
  transition: color 350ms;
  cursor: pointer;

  @media only screen and (min-width: 1024px) {
    &:hover {
      color: ${({theme}) => theme.colors.secondary}
    }
  }
`

// icons
export const DocumentIcon = styled(IconDocument)`
  fill: none;
`;

export const PhotoIcon = styled(IconPhoto)`
  position: absolute;
  z-index: 2;
  bottom: -8px;
  right: -9px;
  fill: none;
`;
